import { Decoration, WidgetType } from "@codemirror/view";
import { hiddenDecoration, shouldHideMarkers } from "../utils/decorationHelper"

class CheckboxWidget extends WidgetType {
  constructor(checked) {
    super();
    this.checked = checked;
  }

  toDOM(view) {
    const input = document.createElement("input");
    input.type = "checkbox";
    input.checked = this.checked;
    input.classList = "cm-markdoc-task-checkbox";
    input.onclick = (e) => {
      e.preventDefault();
      const pos = view.posAtDOM(input);
      const newState = input.checked ? "[x]" : "[ ]";
      view.dispatch({
        changes: {
          from: pos - 3,
          to: pos,
          insert: newState,
        },
      });
    };
    return input;
  }

  eq(other) {
    return other.checked === this.checked;
  }

  ignoreEvent() {
    return false;
  }
}

export function decorateTaskMarker(node, view, widgets, mode = "edit") {
  if (node.from >= node.to) return false;

  const text = view.state.doc.sliceString(node.from, node.to); // e.g., "[x]" or "[ ]"
  const checked = text.includes("x");

  if (shouldHideMarkers(view, node, mode)) {
    widgets.push(
      Decoration.widget({
        widget: new CheckboxWidget(checked),
        side: -1 // Place widget before the marker
      }).range(node.from)
    )
    widgets.push(hiddenDecoration(node.from, node.to));
  }

  return true; // Prevent further processing
}

export function decorateTask(node, view, widgets, mode = "edit") {
  if (node.from >= node.to) return false;


  // const text = view.state.doc.sliceString(node.from, node.to); // e.g., "[x]" or "[ ]"
  // const checked = text.includes("x");

  // if (shouldHideMarkers(view, node, mode)) {
  //   widgets.push(hiddenDecoration(node.from, node.to));
  // }

  return true; // Prevent further processing
}
